import { goto, gotoSSR, loadPage, regexMatch } from './index';
import { initEvent } from './event';
import { api_init } from './api'
import { store_init } from './store'
import { writable, get as store_get } from 'svelte/store';
import { routes, apis as api_routes } from "$src/routes";


export function render(target, init_data) {

    let _url = new URL(location.href);
    let url = writable(_url);
    const errors = writable([]);

    let context = new Map()

    context.set('url', _url);
    context.set('errors', errors);
    context.set('goto', goto(url));
    context.set('api', api_init(context));
    context.set('store', store_init(context, init_data));

    let app;

    function onload(page) {
        if (page.redirect) {
            let goto = context.get('goto')
            goto(page.redirect)
            return;
        }

        if (app) {
            app.$destroy()
        }

        app = new page.render({
            target,
            hydrate: true,
            props: page.props,
            context,
        });
    }

    url.subscribe(url => {
        context.set('url', url);

        loadPage(context, routes, url).then(onload);
    });

    errors.subscribe(errs => {
        if (errs.length > 0) {
            console.error(errs);
        }
    });

    initEvent(context, url)
}

async function apiMatch(ctx, url, context) {
    for (const route of api_routes) {
        const params = regexMatch(route.path, url.pathname);

        if (params) {
            ctx.body = await runApi(route, params, url, context);
            return;
        }
    }

    ctx.status = 404;
}

async function runApi(route, urlParams, url, context) {
    const js = await route.load();

    let params = new URLSearchParams();
    url.searchParams.forEach((v, k) => {
        params.append(k, v);
    });

    for (let key in urlParams) {
        params.set(key, urlParams[key]);
    }

    let api = context.get("api");

    let input = {
        url,
        query: params,
        api,
        context,
    };

    let out = await js.default(input);

    return out;
}

async function renderSSR(ctx, context, template) {
    let url = context.get("url");

    let page = await loadPage(context, routes, url);

    if (!page) {
        ctx.status = 404;
        return;
    }

    if (page.redirect) {
        let href = new URL(page.redirect, url).href;

        ctx.status = 302;
        ctx.set({ location: href });
        return;
    }
    
    let store = context.get("store");
    let size = store.cache.size;
    let resp;

    resp = page.render.render(page.props, { context });

    let init_data = await store.Poll();

    if (size != store.cache.size) {
        resp = page.render.render(page.props, { context });
    }

    let headers = {
        "content-type": "text/html; charset=utf-8",
        ...(page.headers || {}),
    };

    if (resp.css.code) {
        resp.head += "\n<style>\n" + resp.css.code + "\n</style>\n";
    }

    // 5. 注入渲染后的应用程序 HTML 到模板中。
    const out = template
        .replace(`<!--ssr-head-->`, resp.head)
        .replace(`<!--ssr-body-->`, resp.html)
        .replace(
            `<!--ssr-script-->`,
            "<script>\nwindow._init_data_=" +
            JSON.stringify(init_data) +
            "\n</script>"
        );

    // 6. 返回渲染后的 HTML。
    ctx.status = page.status || 200;
    ctx.set(headers);
    ctx.body = out;

    const errors = store_get(context.get("errors"));
    if (errors.length > 0) {
        console.error(ctx.originalUrl + "\n", ...errors);
    }
}

export async function server(ctx, template) {
    let url = ctx.protocol + "://" + ctx.headers.host + ctx.originalUrl;

    url = new URL(url);

    let context = new Map();

    context.set('koaCtx', ctx);
    context.set('errors', writable([]));
    context.set("url", url);
    context.set('goto', gotoSSR())
    context.set('api', api_init(context))
    context.set('store', store_init(context));

    if (url.pathname.match(/\.json$/)) {
        return await apiMatch(ctx, url, context);
    } else {
        return await renderSSR(ctx, context, template);
    }
}
